module.exports = __webpack_public_path__ + "img/飞轮.SLDPRT.834b15c6.jpg";